export const Logo = ({ className = "h-9" }) => (
  <span data-testid="navbar-logo" className="flex items-center select-none">
    <img src="/logo.png" alt="Markagro Global" className={`${className} w-auto`} />
  </span>
);
